import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;

  .header-content {
    text-align: left;
    margin-bottom: 40px;
    width: 100%;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    border-radius: 15px; 
    padding: 24px;
    background: #fff;
  }

  @media (max-width: 768px) {
    .header-content {
      margin-bottom: 30px;
      text-align: center;
      
      h1 {
        font-size: 1.75rem;
      }
    }
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  width: 100%;
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #EBA1C6;
  margin-bottom: 40px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    padding: 20px;
  }
`;

export const SearchContainer = styled.div`
  flex: 1;
  position: relative;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 16px 20px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  font-size: 16px;
  font-family: 'Inter Regular';
  color: #646464ff;
  background-color: #FCFBFD;
  box-sizing: border-box;
  
  &::placeholder {
    color: #6c757d;
    font-size: 15px;
  }
  
  &:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 2px rgba(228, 108, 154, 0.1);
  }
  
  @media (max-width: 768px) {
    font-size: 14px;
    padding: 14px 16px;
  }
`;

export const ProfessionalsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  width: 100%;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;